const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "VHF_DSC_ENABLED_TYPES_RETRIEVED":
            return action.vhfDscEnabledTypes;

        default:
            return state;
    }
}
